import { useState, useEffect } from "react";
import { TextField, Typography, Box, Stack, MenuItem } from "@mui/material";
import MultiInput from "../common/MultiInput.js";

import ReactQuillEditor from "../component/ReactQuillEditor/ReactQuillEditor";
import { CONSTANTS } from "../common/constant.js";
import styles from "../../pages/Home/Tirth/AddNewTirth/AddNewTirth.module.scss";
import { api } from "../../services";

const BasicInformationFields = ({
  handleChange,
  getFieldValue,
  errors,
  page,
}) => {
  const [categories, setCategories] = useState([]);
  const [languages, setLanguages] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const { data } = await api.get(`/categories`);
        setCategories(data?.categories || []);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchCategories();

    const fetchLanguages = async () => {
      try {
        const { data } = await api.get(`/languages`);
        setLanguages(data.languages || []);
      } catch (error) {
        console.error("Error fetching languages:", error);
      }
    };
    fetchLanguages();
  }, []);

  return (
    <Box className={styles.section_container}>
      <Typography variant="h6" gutterBottom>
        {CONSTANTS.BASIC_INFO_SECTION}
      </Typography>
      <Stack spacing={2}>
        <TextField
          fullWidth
          label="Slug"
          name="slug"
          value={getFieldValue("slug") || ""}
          onChange={handleChange}
          required
          error={!!errors["slug"]}
          helperText={errors["slug"]}
        />
        <TextField
          fullWidth
          label={CONSTANTS.TITLE}
          name="title.en"
          value={getFieldValue("title.en") || ""}
          onChange={handleChange}
          required
          error={!!errors["title.en"]}
          helperText={errors["title.en"]}
        />
        <TextField
          fullWidth
          label={CONSTANTS.TITLE_HINDI}
          name="title.hi"
          value={getFieldValue("title.hi") || ""}
          onChange={handleChange}
          required
          error={!!errors["title.hi"]}
          helperText={errors["title.hi"]}
        />
        {page === "book" || page === "blog" ? (
          <>
            <MultiInput
              initialValues={getFieldValue("categories") || []}
              options={categories}
              onChange={handleChange}
              name="categories"
              label={CONSTANTS.CATEGORY}
              type="object"
              select
            />
            {errors["categories"] && (
              <Typography color="error" variant="caption">
                {errors["categories"]}
              </Typography>
            )}
          </>
        ) : (
          <></>
        )}

        {page === "book" ? (
          <TextField
            fullWidth
            label={CONSTANTS.LANGUAGE}
            name="languageId"
            value={getFieldValue("languageId") || ""}
            onChange={handleChange}
            select
            required
            error={!!errors["languageId"]}
            helperText={errors["languageId"]}
          >
            {languages.map((lang) => (
              <MenuItem key={lang._id} value={lang._id}>
                {lang.name.en}-{lang.name.hi} ({lang.code})
              </MenuItem>
            ))}
          </TextField>
        ) : (
          <></>
        )}
        <Stack spacing={2}>
          <TextField
            fullWidth
            label={CONSTANTS.SHORT_DESCRIPTION}
            name="shortDescription.en"
            value={getFieldValue("shortDescription.en") || ""}
            onChange={handleChange}
            required
            multiline
            minRows={2}
            error={!!errors["shortDescription.en"]}
            helperText={errors["shortDescription.en"]}
          />
          <TextField
            fullWidth
            label={CONSTANTS.SHORT_DESCRIPTION_HINDI}
            name="shortDescription.hi"
            value={getFieldValue("shortDescription.hi") || ""}
            onChange={handleChange}
            required
            multiline
            minRows={2}
            error={!!errors["shortDescription.hi"]}
            helperText={errors["shortDescription.hi"]}
          />
          <ReactQuillEditor
            value={getFieldValue("longDescription.en") || ""}
            // setValue={(value) => handleChange("visitingHours.en", value)}
            setValue={(value) =>
              handleChange({
                target: { name: "longDescription.en", value },
              })
            }
            placeholder="Write long description here..."
            error={!!errors["longDescription.en"]}
            helperText={"longDescription.en"}
          />
          <ReactQuillEditor
            value={getFieldValue("longDescription.hi") || ""}
            // setValue={(value) => handleChange("visitingHours.hi", value)}
            setValue={(value) =>
              handleChange({
                target: { name: "longDescription.hi", value },
              })
            }
            placeholder="यहाँ लंबा विवरण..."
            error={!!errors["longDescription.hi"]}
            helperText={"longDescription.hi"}
          />
        </Stack>
      </Stack>
    </Box>
  );
};

export default BasicInformationFields;
